import { Box } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentLinkList } from 'declarations/contentful';

import Container from './shared/Container';

const RenderLinkList = (entry: ILpComponentLinkList) => {
  const { fields, sys } = entry;
  const { locale } = sys;

  return (
    <Container className="flex flex-col items-center py-4">
      <Box
        role="list"
        className="z-[3] inline-flex flex-row rounded-full border border-od-border-primary p-0"
      >
        {fields.links?.map((link, idx) => (
          <Box role="listitem" key={idx} className="inline-flex">
            {locale !== 'es' && (
              <Box
                href={link.fields.url ?? ''}
                aria-label={`Go to page ${link.fields.text}`}
                analyticsName={`cosmos-landing-page-link-list-${fields.analyticsId || ''}-${
                  link.fields.text
                }`}
                className={cn(
                  'rounded-full px-6 py-2',
                  link.fields.active ? 'bg-od-bg-accent-brand' : 'bg-transparent',
                )}
              >
                <Text
                  as="span"
                  className={cn(
                    'font-medium no-underline',
                    link.fields.active
                      ? 'text-od-content-inverse-primary'
                      : 'text-od-content-accent-brand',
                  )}
                >
                  {link.fields.text}
                </Text>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const LinkList: EntryComponent<ILpComponentLinkList> = {
  render: RenderLinkList,
};

export default LinkList;
